import { BREAKPOINT_TABLET, CARD_MARGINS } from "../constants/constants";
import { useGetPageFromPath } from "utils/customHooks/genericHooks";
import { useMediaQuery } from "@mui/material";
import { useMemo } from "react";

const MOBILE = "mobile";

export function useCardMargins() {
  const { pageName } = useGetPageFromPath();
  const isTabletOrLarger = useMediaQuery(`(min-width: ${BREAKPOINT_TABLET}px)`);

  return useMemo(() => {
    const cardMarginInner = CARD_MARGINS[isTabletOrLarger ? pageName : MOBILE];
    return {
      cardMarginInner,
      cardMarginOuter: isTabletOrLarger ? cardMarginInner : 5, // shrink outer margin on mobile to save hz space
    };
  }, [pageName, isTabletOrLarger]);
}
